<template>
  <div class="">
    <el-form
      ref="ruleForm"
      :inline="true"
      :model="formModel"
      class="demo-form-inline"
    >
      <el-form-item label="手机号：" prop="group">
        <el-input
          v-model="formModel.username"
          class="inputL310"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item label="密码：" prop="group">
        <el-input
          v-model="formModel.pwd"
          class="inputL310"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item label="" style="margin-top">
        <el-button
          type="primary"
          class="btnw190"
          @click="submitForm('ruleForm')"
          >确定
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import api from "@/api/common";
import {
  setUserAccessToken
} from "@/utils/auth";
import { setCookieWithDuration } from "@/utils/index";
export default {
  data() {
    return {
      formModel: {
        client_type: "pc",
        username: "", //手机号
        pwd: "", //密码
      },
    };
  },
  created() {},
  methods: {
    submitForm() {
      api.login({...this.formModel}).then((res) => {
        if (res.code == 0) {
          setUserAccessToken(
            'think:' + JSON.stringify({token: res.data.token}),
            setCookieWithDuration(res.data.token.refresh_expires_in)
          );
          this.$router.push({path:'/bookShelf'})
          //存储登录信息
          this.$store.dispatch("loginUserInfo", res.data);
        } else {
          this.$message.error(res.msg);
        }
      }).catch(() => {});
    },
  },
};
</script>
   
<style scoped lang='scss'>
</style>